import { useCallback } from 'react';
import { setRef } from '../utils/ref.js';

/**
 * Sets the native `autofocus` attribute on the element when it mounts. This is different from
 * react's `autoFocus` prop in that it only works to autofocus elements within modals, rather
 * than on mount.
 *
 * @note Controlled modals that mount/unmount when opened/closed can use React's `autoFocus` prop.
 *
 * @param otherRef An optional ref to merge with the autofocus ref.
 * @param shouldAutofocus Whether the element should autofocus. Defaults to true.
 * @returns A ref to pass to the element you want to autofocus.
 */
function useAutofocus(otherRef, shouldAutofocus = true) {
    return useCallback((el) => {
        setRef(otherRef, el);
        if (el)
            el.autofocus = shouldAutofocus;
    }, [otherRef, shouldAutofocus]);
}

export { useAutofocus };
//# sourceMappingURL=use-autofocus.js.map
